const dispatchResourceUrl = params =>
  params?.dispatchApiUrl ??
  `${params?.getApiUrl()}/sxcl/v1/service-provider-profile/${params?.serviceProviderId}/dispatch`;

const basicResourceUrl = params =>
  params?.basicApiUrl ??
  `${params?.getApiUrl()}/sxcl/v1/service-providers/${params?.serviceProviderId}`;

const fetchDispatchDetails = async params => {
  const response = await params?.get(dispatchResourceUrl(params));
  return response;
};

const fetchBasicDetails = async params => {
  const response = await params?.get(basicResourceUrl(params));
  return response;
};

const submitDispatchDetails = async (params, data, permissions) => {
  const { plusoneExternalReferenceId, ...rest } = data;
  let updatedPageData = {
    ...rest,
  };
  if (permissions?.plusoneExternalReferenceId === 'WRITE') {
    updatedPageData = {
      plusoneExternalReferenceId,
      ...updatedPageData,
    };
  }
  const response = await params?.put(
    dispatchResourceUrl(params),
    updatedPageData,
  );
  return response;
};

const submitBasicDetails = async (params, data, defaultValues) => {
  const url = basicResourceUrl(params);
  if (data?.serviceProviderType?.value) {
    const requestData = {
      serviceProviderType: {
        id: data.serviceProviderType?.value,
      },
    };
    const response = await params?.put(url, requestData);
    return response;
  }
  return {
    ok: true,
    data: {
      serviceProviderType: {
        typeName: defaultValues.serviceProviderType?.label,
        id: defaultValues.serviceProviderType?.value,
      },
    },
  };
};

export {
  fetchDispatchDetails,
  fetchBasicDetails,
  submitDispatchDetails,
  submitBasicDetails,
};
